var _ = require('lodash');
var React = require('react');
var Reflux = require('reflux');

var storyScenarios = require('models/storyScenarios');

var ScrollSpyContentsMixin = require('views/scrollSpy/ScrollSpyContentsMixin');

var SCROLLSPY_PROPS = {
  id: 'scenario-series-b',
  name: 'Series B'
}

module.exports = React.createClass({displayName: "module.exports",
  mixins: [ScrollSpyContentsMixin],

  getInitialState:function() {
    return {
      scrollSpy: SCROLLSPY_PROPS
    };
  },

  onScrollSpyFocus: function(target) {
    actions.ui.showPVScatter(true);
    actions.chart.showFirstRoundLabels(false);
    actions.round.setScenario(storyScenarios.rounds.seriesB);
    actions.chart.selectRound(storyScenarios.rounds.seriesB);
  },

  render:function() {
    return (
      React.createElement("div", {id: SCROLLSPY_PROPS.id}, 
        React.createElement("h2", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Series B: Keep Growing the Pie"), 
        React.createElement("p", null, 
          "More months have gone by, and this time you got an additional ", React.createElement("span", {className: "highlight-round-money"}, React.createElement("strong", null, "$ 6M")), "!" + " " +
          "You're making this look easy!"
        )
      )
    );
  }
});


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jsx-loader?harmony!./views/scrollSpyContents/SeriesB.jsx
 **/